import { antiAging, antiAgingBeluga } from './initial/flow';
import antiAgingBelugaFollowup from './monthly/flow';

const antiAgingFlows = { antiAgingBeluga, antiAgingBelugaFollowup, antiAging };

export default antiAgingFlows;
